import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUsdDollar = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0098 21.01C16.9798 21.01 21.0098 16.98 21.0098 12.01C21.0098 7.04001 16.9798 3.01001 12.0098 3.01001C7.03977 3.01001 3.00977 7.04001 3.00977 12.01C3.00977 16.98 7.03977 21.01 12.0098 21.01Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.51953 13.89C9.51953 14.86 10.2695 15.64 11.1895 15.64H13.0695C13.8695 15.64 14.5195 14.96 14.5195 14.11C14.5195 13.2 14.1195 12.87 13.5295 12.66L10.5195 11.61C9.92953 11.4 9.52953 11.08 9.52953 10.16C9.52953 9.32001 10.1795 8.63 10.9795 8.63H12.8595C13.7795 8.63 14.5295 9.41 14.5295 10.38",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0195 7.63V16.64",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUsdDollar;
